$ = require 'jquery'
Backbone = require 'app/scripts/lib/backbone'
Storage = require 'app/scripts/lib/storage'
_ = require 'underscore'

lastActivity = 0
sessionStorage = window.sessionStorage
status = sessionStorage?.status ? 'active'
hiddenProperty = null
visibilityChange = null

# From https://developer.mozilla.org/en-US/docs/Web/Guide/User_experience/Using_the_Page_Visibility_API
if typeof document.hidden != 'undefined'
  # Opera 12.10 and Firefox 18 and later support
  hiddenProperty = 'hidden'
  visibilityChange = 'visibilitychange'
else if typeof document.mozHidden != 'undefined'
  hiddenProperty = 'mozHidden'
  visibilityChange = 'mozvisibilitychange'
else if typeof document.msHidden != 'undefined'
  hiddenProperty = 'msHidden'
  visibilityChange = 'msvisibilitychange'
else if typeof document.webkitHidden != 'undefined'
  hiddenProperty = 'webkitHidden'
  visibilityChange = 'webkitvisibilitychange'

module.exports = Monitor =
  init: ->
    setInterval(Monitor.check, 10 * 1000)

    # Mark the user active if...
    # the window gets the focus
    # Note: since we can also detect when the window
    # loses the focus, we can make it so a window that
    # has no interaction but has the focus stays active
    # e.g. if someone is just staring at the board, but not
    # doing anything
    $(window).on 'focus', -> Monitor.addActivity()

    # the user presses a key or clicks something
    $(document).on 'keydown mousedown', ->
      Monitor.addActivity()
      return

    Monitor.getHidden = if hiddenProperty?
      -> document[hiddenProperty]
    else
      -> false

    if visibilityChange?
      $(document).on visibilityChange, =>
        Monitor.trigger 'visibilitychange'

    return

  addActivity: ->
    now = (new Date()).getTime()
    lastActivity = now

    Storage.set('lastActivity', lastActivity)

    Monitor.setStatus('active')
    return

  check: ->
    delta = (new Date()).getTime() - Math.max(lastActivity, if Storage.isEnabled() then parseInt(Storage.get('lastActivity')) else 0)

    Monitor.setStatus('idle') if (delta > 5 * 60 * 1000) # 5 minutes
    return

  setStatus: (newStatus) ->
    if (newStatus != status)
      status = newStatus
      sessionStorage.status = status if sessionStorage
      Monitor.trigger('setStatus', status)
    return

  getStatus: -> status

_.extend Monitor, Backbone.Events
